export default {
      id: "ic_arrow up-usage",
      viewBox: "0 0 32 26",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#ic_arrow up-usage",
      toString: function () {
        return this.url;
      }
    }